import { AccountModel } from 'data-ng-authentication';
import { ApplicationConfiguration } from '../../models/app_config_model';
import * as _4 from 'lodash4';

export interface IEmailData {
  to?: [string] | string;
  subject: string;
  body?: string;
}

export class EmailManagementService {
  private supportEmail: string = 'NavigateStudentTechSupport@eab.com';

  constructor(
    private accountModel: AccountModel,
    private appConfigModel: ApplicationConfiguration,
    private $location: ng.ILocationService,
    private $window: ng.IWindowService
  ) {}

  trackingId(): string {
    const tracking_id = this.accountModel.tracking_id;
    return tracking_id ? `\n** Reference#: ${tracking_id}` : tracking_id;
  }

  studentNK(): string {
    const student_nk = this.accountModel.student_nk;
    return student_nk ? `\n** Student_NK#: ${student_nk}` : student_nk;
  }

  institutionName(): string {
    return `\n** Institution Name: ${this.appConfigModel.getConfigProperty('core-inst_name')}`;
  }

  currentPageURL(): string {
    return `\n** Page URL: ${this.$location.absUrl()}`;
  }

  userType(): string {
    const userType: string = '\n** User Type: ';
    if (this.accountModel.isAdvisor) {
      return `${userType}Advisor`;
    }
    if (this.accountModel.isInstructor) {
      return `${userType}Instructor`;
    }
    return `${userType}Student`;
  }

  private getSupportEmailSubject(isFeedback: boolean): string {
    return isFeedback ? `User feedback` : `User Support`;
  }

  private getSupportEmailBody(isFeedback: boolean): string {
    return isFeedback
      ? '< Type in what feedback you would like to provide >'
      : '< Type in what problem you would like to report >';
  }

  private emailFieldStrings(text?: string | string[]): string {
    return text ? _4.toString(text) : '';
  }

  sendSupportEmail(data: IEmailData, isFeedBack: boolean): void {
    const emailData: IEmailData = {
      to: this.supportEmail,
      subject: this.getSupportEmailSubject(isFeedBack),
      body: `${this.getSupportEmailBody(isFeedBack)}
                    ${this.trackingId()}
                    ${this.studentNK()}
                    ${this.userType()}
                    ${this.institutionName()}
                    ${this.currentPageURL()}`
    };

    this.sendEmail(_4.merge(emailData, data));
  }

  sendEmail(emailData: IEmailData): void {
    const url: string = `mailto:${_4.toString(emailData.to)}?
          ${emailData.subject ? 'subject=' + _4.toString(emailData.subject) : ''}
          ${emailData.body ? '&body=' + _4.toString(emailData.body) : ''}`;
    this.$window.open(url);
  }
}



// WEBPACK FOOTER //
// ./app/lib/core/services/email_management_service.ts